<form [formGroup]="form()">
  <app-typeahead
    [controlName]="controlName()"
    [form]="form()"
    (searchChanged)="creditorIdSearchChanged($event)"
    [resultSelected]="directDebitSelected"
    (keyboardSelected)="keyboardSelectedCreditor($event)"
    [label]="label()"
    [canNavigateByKeys]="true"
    [loading]="creditorLoading()"
    [results]="creditorResults()"
    [resultTemplate]="creditorItemTpl"
    ngDefaultControl
  ></app-typeahead>
</form>

<ng-template #creditorItemTpl let-item>
  @if (item) {
    <div
      [class.has-click]="!item.closed"
      class="is-flex is-justify-content-center is-align-items-center is-flex-direction-column"
      (click)="handleCreditorResultSelected(item)"
    >
      <div class="is-flex">
        @if (isIgnorableCreditor(item)) {
          <fino-icon icon="Remove" class="has-text-danger is-small mt-2 mr-2"></fino-icon>
        }

        <strong class="is-size-6">{{ item.name }}</strong> <br />
      </div>
      <div class="has-text-grey is-size-6">
        <div>
          <small>{{ (item.creditorId | creditor) || '-' }}</small>
          <br />
        </div>
      </div>
    </div>
  }
</ng-template>
